<!-- ============================================================
  BEATS LICENSE MODAL
  ============================================================ -->
<ng-container *ngIf="!isSoundKit; else soundKitTemplate">
  <div class="ipm-license-modal" [class.ipm-license-modal--compare]="isShowCompareLicense" [class.is-diwali]="isSaleLive" *ngIf="!isShowLicense; else showLicenseTemplate" >

    <!-- HEADER -->
    <div class="ipm-lm-header">
      <div class="ipm-lm-thumb ipm-play-music" (click)="playMusic()">
        <img [src]="beatData?.cover_picture" class="ipm-lm-thumb-img" alt="cover" priority>
        <span class="ipm-disc-badge" *ngIf="beatData?.sale_info?.is_on_sale &&commonServices.isBeatOnSale(beatData)">{{beatData?.sale_info?.discount_tier}}%</span>
        <div class="ipm-lm-thumb-overlay">
          <i class="fa fa-play" *ngIf="!beatData?.isPlayMusic"></i>
          <i class="fas fa-pause" *ngIf="beatData?.isPlayMusic"></i>
        </div>
        <div class="ipm-beat-types-tag"
             *ngIf="beatData?.category === 'beat_with_hook' || beatData?.category === 'switch_beat'">
          <span>{{ beatData?.category | getFilterKeysName : 'beatTypes' }}</span>
        </div>
      </div>

      <div class="ipm-lm-track-info">
        <span class="ipm-lm-track-title" (click)="redirectDetails(beatData, 'beat')">
          {{ beatData?.title }}
          <span class="ipm-lm-coupon-badge"
                *ngIf="beatData?.available_coupons && beatData.available_coupons.length > 0">
            <img src="./assets/imgs/sub-menu/coupon-icon-beat.svg" alt="coupon" priority>
          </span>
        </span>
        <span class="ipm-lm-track-artist" (click)="redirectDetails(beatData)">
          {{ beatData?.producer?.store?.general?.name }}
          <img class="ipm-lm-verify"
               *ngIf="(beatData.producer?.tiers | getSubsTires : 'producer') === 'tier1'"
               src="./assets/imgs/subs_premium_tick.svg" alt="verified" priority>
          <img class="ipm-lm-verify"
               *ngIf="(beatData.producer?.tiers | getSubsTires : 'producer') === 'tier2'"
               src="./assets/imgs/subs_pro_tick_img.png" alt="verified" priority>
        </span>
      </div>

      <button class="ipm-lm-close-btn" *ngIf="!isShowLicense"  (click)="closeDialog()" aria-label="Close">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
        </svg>
      </button>
    </div>

    <!-- BODY -->
    <div class="ipm-lm-body">
      <ng-container *ngIf="isShowCompareLicense; else licenseChooserTemplate">
        <div class="ipm-lm-compare-view">
          <div class="ipm-lm-compare-head">
            <!-- <div>
              <span class="ipm-lm-compare-title">Compare</span>
              <span class="ipm-lm-compare-hint">Tap a license to select it</span>
            </div> -->

            <button class="ipm-lm-compare-back" type="button" (click)="onCompareBackClick()">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
              Back
            </button>
          </div>

          <div class="ipm-lm-compare-scroll">
            <table class="ipm-lm-compare-table">
              <thead>
                <tr>
                  <th class="ipm-lm-compare-corner">License terms</th>
                  <th *ngFor="let tier of uiTiers"
                      class="ipm-lm-compare-tier"
                      [class.ipm-lm-compare-tier-selected]="licType === tier.slug"
                      [attr.data-slug]="tier.slug"
                      (click)="onChangeView(tier.slug)">
                    <span class="ipm-lm-compare-popular" *ngIf="tier.popular && tier.slug !== 'wav_stem'">Popular</span>
                    <span class="ipm-lm-compare-tier-name">{{ tier.name }}</span>
                    <span class="ipm-lm-compare-tier-price">
                      <ng-container *ngIf="tier.hasDiscount; else compareNoDiscount">
                        <span class="ipm-lm-original-price strike-through">{{ tier.originalPriceStr }}</span>
                        <span class="ipm-lm-discounted-price">{{ tier.discountedPriceStr }}</span>
                      </ng-container>
                      <ng-template #compareNoDiscount>
                        {{ tier.priceStr }}
                      </ng-template>
                    </span>
                    <span class="ipm-lm-compare-selected" *ngIf="licType === tier.slug">Selected</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let compareRow of compareLicenseRows">
                  <td class="ipm-lm-compare-row-label">{{ compareRow.label }}</td>
                  <td *ngFor="let tier of uiTiers"
                      [class.ipm-lm-compare-cell-selected]="licType === tier.slug"
                      [attr.data-slug]="tier.slug"
                      (click)="onChangeView(tier.slug)">
                    <span>{{ compareRow.values[tier.slug] }}</span>
                    <span class="ipm-lm-compare-seller"
                          *ngIf="compareRow.sellerSlugs?.includes(tier.slug)">
                      Seller
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>

      <ng-template #licenseChooserTemplate>

<!-- Section label row -->
       <div class="ipm-lm-section-row">
         <span class="ipm-lm-section-title">Choose your license</span>
       </div>

      <!-- TIER CARDS -->
      <div class="ipm-lm-tier-grid">
        <ng-container *ngFor="let tier of uiTiers">
          <div class="ipm-lm-tier-wrapper" (click)="scrollTierIntoView($event)">

            <div class="ipm-lm-popular-badge"
                 [class.ipm-lm-popular-badge--selected]="licType === tier.slug"
                 [attr.data-slug]="tier.slug"
                 *ngIf="tier.popular">
              <svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 16.8l-6.2 4.5 2.4-7.4L2 9.4h7.6z"/>
              </svg>
              Most popular
            </div>

            <div class="ipm-lm-tier-card"
                 [class.ipm-lm-tier-selected]="licType === tier.slug"
                 [attr.data-slug]="tier.slug"
                 (click)="onChangeView(tier.slug)"
                 role="button"
                 [attr.aria-pressed]="licType === tier.slug">
              <!-- Diwali sale: discount corner badge -->
              <span class="ipm-lm-tier-off" *ngIf="isSaleLive && tier.saleOff">{{ tier.saleOff }}%</span>
              <div class="ipm-lm-tier-name">{{ tier.name }}</div>
              <div class="ipm-lm-tier-price">
                <ng-container *ngIf="tier.hasDiscount; else noDiscountTpl">
                  <span class="ipm-lm-original-price strike-through">{{ tier.originalPriceStr }}</span>
                  <span class="ipm-lm-discounted-price">{{ tier.discountedPriceStr }}</span>
                </ng-container>
                <ng-template #noDiscountTpl>
                  {{ tier.priceStr }}
                </ng-template>
              </div>
              <div class="ipm-lm-tier-formats">{{ tier.formats }}</div>
              <div class="ipm-lm-tier-best" *ngIf="!commonServices.isMobileDisableClick">{{ tier.best }}</div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- TERMS PANEL -->
      <div class="ipm-lm-terms-panel" *ngIf="activeTierMeta">

        <!-- Sample details table -->
        <ng-container *ngIf="isShowSampleDetails">
          <div class="ipm-lm-sample-view">

            <div class="ipm-lm-sample-header">
              <span class="ipm-lm-sample-title">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
                </svg>
                Used Samples
              </span>
              <button class="ipm-lm-sample-back-btn" (click)="isShowSampleDetails = false">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
                Back
              </button>
            </div>

            <div class="ipm-lm-sample-list">
              <div class="ipm-lm-sample-row" *ngFor="let s of beatData?.used_samples; let i = index">
                <span class="ipm-lm-sample-index">{{ i + 1 }}</span>
                <span class="ipm-lm-sample-name">{{ s?.artist_name }}</span>
                <span class="ipm-lm-sample-status" [class.ipm-lm-sample-status--cleared]="s?.is_royalty_free" [class.ipm-lm-sample-status--pending]="!s?.is_royalty_free">
                  <ng-container *ngIf="s?.is_royalty_free">
                    <!-- <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg> -->
                    Royalty Free
                  </ng-container>
                  <ng-container *ngIf="!s?.is_royalty_free">
                    <!-- <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg> -->
                    Clearance Required
                  </ng-container>
                </span>
              </div>
            </div>

          </div>
        </ng-container>

          <!-- Features list — coverflow carousel -->
          <ng-container *ngIf="!isShowSampleDetails">
            <div class="ipm-lm-terms-delta-row">
              <p class="ipm-lm-terms-delta">{{ activeTierMeta.delta }}</p>

              <div class="ipm-lm-terms-actions">
                <button class="ipm-lm-term-chip ipm-lm-term-chip--compare"
                        type="button"
                        (click)="onCompareLicenseClick()">
                  <span class="ipm-lm-term-chip-icon"
                        [innerHTML]="getTermIconSvg('compare', '#FFF')"></span>
                  <span class="ipm-lm-term-chip-text">Compare</span>
                </button>
                <button class="ipm-lm-term-chip ipm-lm-term-chip--used"
                        *ngIf="beatData?.used_samples && beatData.used_samples.length > 0"
                        type="button"
                        (click)="onUsedSampleClick()">
                  <span class="ipm-lm-term-chip-icon"
                        [innerHTML]="getTermIconSvg('music', '#FFFF')"></span>
                  <span class="ipm-lm-term-chip-text">
                    Used samples
                    <!-- <small>
                      {{ beatData.used_samples.length }} sample(s)
                      <ng-container *ngIf="isNotRoyaltyCount === 0">all cleared</ng-container>
                      <ng-container *ngIf="isNotRoyaltyCount > 0">{{ isNotRoyaltyCount }} clearance(s) required</ng-container>
                    </small> -->
                  </span>
                </button>

              </div>
            </div>
            <ng-container *ngIf="!commonServices.isMobileDisableClick; else mobileTermsTemplate">
              <div class="ipm-lm-terms-coverflow" (wheel)="onTermsWheel($event)">
                <owl-carousel-o #termsCarousel [options]="termsCarouselOptions" (translated)="onTermsCarouselTranslated($event)">
                  <ng-template carouselSlide *ngFor="let term of licenseTerms; let i = index">
                    <div class="ipm-lm-cf-card"
                         [class.ipm-lm-cf-card--action]="term.title === 'Read Full License'"
                         (click)="onTermSlideClick(i, term)">
                      <span class="ipm-lm-cf-icon"
                            [innerHTML]="getTermIconSvg(term.icon, activeTierMeta.accent)"></span>
                      <span class="ipm-lm-cf-title">{{ term.title }}</span>
                      <span class="ipm-lm-cf-value">{{ term.value }}</span>
                      <span class="ipm-lm-cf-description">{{ term.description }}</span>
                    </div>
                  </ng-template>
                </owl-carousel-o>
              </div>
            </ng-container>
          </ng-container>

      </div>
      </ng-template>
    </div>

    <!-- FOOTER -->
    <div class="ipm-lm-footer">
      <!-- Diwali sale: TOTAL ~~old~~ | DIWALI OFFER new (Save x) -->
      <div class="ipm-lm-footer-total ipm-lm-footer-total--diwali" *ngIf="isSaleLive && activeTierMeta?.saleOff; else regularTotal">
        <span class="ipm-lm-total-label">Total</span>
        <span class="ipm-lm-total-orig">{{ activeTierMeta?.originalPriceStr }}</span>
        <span class="ipm-lm-total-divider"></span>
        <span class="ipm-lm-total-offer-label">Diwali Offer</span>
        <span class="ipm-lm-total-offer-price">{{ activeTierMeta?.discountedPriceStr }}</span>
        <span class="ipm-lm-total-save">Save {{ activeTierMeta?.saveStr }}</span>
      </div>
      <ng-template #regularTotal>
      <div class="ipm-lm-footer-total">
        <span class="ipm-lm-total-label">Total</span>
        <span class="ipm-lm-total-price">
          <ng-container *ngIf="activeTierMeta?.hasDiscount; else normalPrice">
            <span class="ipm-lm-original-price strike-through">{{ activeTierMeta?.originalPriceStr }}</span>
            <span class="ipm-lm-discounted-price">{{ activeTierMeta?.discountedPriceStr }}</span>
          </ng-container>
          <ng-template #normalPrice>
            {{ activeTierMeta?.priceStr }}
          </ng-template>
        </span>
      </div>
      </ng-template>

      <div class="ipm-lm-footer-actions">
        <!-- Negotiate (exclusive + negotiation allowed) -->
        <button class="ipm-lm-btn ipm-lm-btn-negotiate"
                *ngIf="(beatData?.prices | checkExclusiveLic).isShowExclusive
                       && selectedLicData?.title === 'Exclusive'
                       && priceData?.negotiationAllow"
                (click)="startNewNegotiation()">
          <img src="./assets/imgs/negotiation.png" alt="negotiate" width="15" height="15">
          <ng-container *ngIf="priceData?.negotiationObj && priceData?.negotiationObj.isActive; else negoLabel">
            <ng-container *ngIf="priceData?.negotiationObj?.acceptedOffer; else negotiatingLabel">Negotiated</ng-container>
            <ng-template #negotiatingLabel>Negotiating</ng-template>
          </ng-container>
          <ng-template #negoLabel>Negotiate</ng-template>
        </button>

        <!-- Add to cart -->
        <button class="ipm-lm-btn ipm-lm-btn-cart" (click)="addToCart(false)">
          <i class="pi pi-shopping-cart"></i>
          Add to cart
        </button>

        <!-- Buy now (Diwali sale price selected: orange sale button with the offer price) -->
        <button class="ipm-lm-btn ipm-lm-btn-buy"
                [class.ipm-sale-price-btn]="isSaleLive && activeTierMeta?.saleOff"
                [style.background]="isSaleLive && activeTierMeta?.saleOff ? null : activeTierMeta?.buyBg"
                [style.color]="isSaleLive && activeTierMeta?.saleOff ? null : activeTierMeta?.buyText"
                type="button"
                (click)="buyNowFlow()">
          <ng-container *ngIf="isSaleLive && activeTierMeta?.saleOff; else buyNowLabel">
            <i class="pi pi-shopping-cart"></i>
            <span>{{ activeTierMeta?.discountedPriceStr }}</span>
          </ng-container>
          <ng-template #buyNowLabel>Buy Now</ng-template>
        </button>
      </div>
    </div>

  </div>
</ng-container>

<ng-template #showLicenseTemplate>
  <div class="ipm-license-modal">

    <!-- Header: back button + close -->
    <div class="ipm-lm-header">
      <button class="ipm-lm-license-back" type="button" (click)="isShowLicense = false">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
        Back
      </button>
    </div>

    <!-- Inline license agreement -->
    <div class="ipm-lm-license-agreement">
      <ipm-license-agreement [licensedData]="inlineLicenseData"></ipm-license-agreement>
    </div>

  </div>
</ng-template>

<!-- ============================================================
  SOUND KIT LICENSE MODAL
  ============================================================ -->
<ng-template #soundKitTemplate>
  <div class="ipm-license-modal ipm-license-modal--soundkit" *ngIf="!isShowLicense; else showLicenseTemplate">

    <!-- HEADER -->
    <div class="ipm-lm-header">
      <div class="ipm-lm-thumb">
        <img [src]="beatData?.cover_picture" class="ipm-lm-thumb-img" alt="cover" priority>
        <span class="ipm-disc-badge" *ngIf="commonServices.isBeatOnSale(beatData)">{{beatData?.sale_info?.discount_tier}}%</span>
      </div>

      <div class="ipm-lm-track-info">
        <span class="ipm-lm-track-title" (click)="redirectDetails(beatData, contentType)">
          {{ beatData?.title }}
        </span>
        <span class="ipm-lm-track-artist" (click)="redirectDetails(beatData)">
          {{ beatData?.producer?.name || beatData?.producer?.store?.general?.name }}
          <img class="ipm-lm-verify"
               *ngIf="(beatData.producer?.tiers | getSubsTires : 'producer') === 'tier1'"
               src="./assets/imgs/subs_premium_tick.svg" alt="verified" priority>
          <img class="ipm-lm-verify"
               *ngIf="(beatData.producer?.tiers | getSubsTires : 'producer') === 'tier2'"
               src="./assets/imgs/subs_pro_tick_img.png" alt="verified" priority>
        </span>
      </div>

      <button class="ipm-lm-close-btn" (click)="closeDialog()" aria-label="Close">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
        </svg>
      </button>
    </div>

    <!-- BODY -->
    <div class="ipm-lm-body">
            <!-- Section label row -->
      <div class="ipm-lm-section-row">
        <span class="ipm-lm-section-title">Choose your license</span>
      </div>

      <!-- TIER CARDS -->
      <div class="ipm-lm-tier-grid">
        <ng-container *ngFor="let tier of uiTiers">
          <div class="ipm-lm-tier-card"
               [class.ipm-lm-tier-selected]="licType === tier.slug"
               [attr.data-slug]="tier.slug"
               (click)="onChangeView(tier.slug)"
               role="button"
               [attr.aria-pressed]="licType === tier.slug">

            <div class="ipm-lm-tier-name">{{ tier.name }}</div>
            <div class="ipm-lm-tier-price">
              <ng-container *ngIf="tier.hasDiscount; else noDiscountTplSK">
                <span class="ipm-lm-original-price strike-through">{{ tier.originalPriceStr }}</span>
                <span class="ipm-lm-discounted-price">{{ tier.discountedPriceStr }}</span>
              </ng-container>
              <ng-template #noDiscountTplSK>
                {{ tier.priceStr }}
              </ng-template>
            </div>
            <div class="ipm-lm-tier-formats">{{ tier.formats }}</div>
            <div class="ipm-lm-tier-best" *ngIf="!commonServices.isMobileDisableClick">{{ tier.best }}</div>
          </div>
        </ng-container>
      </div>

          <!-- Terms panel for sound kits -->
           <div class="ipm-lm-terms-panel">
             <div class="ipm-lm-terms-coverflow" *ngIf="!commonServices.isMobileDisableClick; else mobileTermsTemplate" (wheel)="onTermsWheel($event)">
               <owl-carousel-o #termsCarousel [options]="termsCarouselOptions" (translated)="onTermsCarouselTranslated($event)">
                 <ng-template carouselSlide *ngFor="let term of licenseTerms; let i = index">
                   <div class="ipm-lm-cf-card"
                        [class.ipm-lm-cf-card--action]="term.title === 'Read Full License'"
                        (click)="onTermSlideClick(i, term)">
                     <span class="ipm-lm-cf-icon"
                           [innerHTML]="getTermIconSvg(term.icon, activeTierMeta?.accent)"></span>
                     <span class="ipm-lm-cf-title">{{ term.title }}</span>
                     <span class="ipm-lm-cf-value">{{ term.value }}</span>
                     <span class="ipm-lm-cf-description">{{ term.description }}</span>
                   </div>
                 </ng-template>
               </owl-carousel-o>
             </div>
           </div>
    </div>

    <!-- FOOTER -->
    <div class="ipm-lm-footer">
      <div class="ipm-lm-footer-total">
        <span class="ipm-lm-total-label">Total</span>
        <span class="ipm-lm-total-price ipm-lm-total-price--wav">
          <ng-container *ngIf="activeTierMeta?.hasDiscount; else skNormal">
            <span class="ipm-lm-original-price strike-through">{{ activeTierMeta?.originalPriceStr }}</span>
            <span class="ipm-lm-discounted-price">{{ activeTierMeta?.discountedPriceStr }}</span>
          </ng-container>
          <ng-template #skNormal>
            {{ activeTierMeta?.priceStr }}
          </ng-template>
        </span>
      </div>

      <div class="ipm-lm-footer-actions">
        <!-- Credits button (sound kits only) -->
        <button class="ipm-lm-btn ipm-lm-btn-credit"
                *ngIf="beatData?.creditPrice"
                (click)="isUserLogin && isBasicPlan ? requestCreditUpgrade() : purchaseCredit()"
                [disabled]="(beatData?.creditPrice > currentCreditBalance || beatData?.creditPrice === 0) && !isBasicPlan">
          <img src="assets/imgs/Lightning.svg" alt="credits" width="15" height="15">
          {{ beatData?.creditPrice === 0 ? 'Free' : beatData?.creditPrice }} Credits
        </button>

        <button class="ipm-lm-btn ipm-lm-btn-cart" (click)="addToCart(false)">
          <i class="pi pi-shopping-cart"></i>
          Add to cart
        </button>

        <button class="ipm-lm-btn ipm-lm-btn-buy ipm-lm-btn-buy--wav" (click)="buyNowFlow()">
          Buy Now
        </button>
      </div>
    </div>

  </div>
</ng-template>


<!-- ============================================================
  COUPON POPUP TEMPLATE
  ============================================================ -->
<ng-template #couponAvailablePopup let-data>
  <div class="ipm-applied-coupon-section" [class.ipm-diwali-coupon-popup]="isSaleLive">
    <div class="ipm-heading-model-section">
      <div class="ipm-close-icon" (click)="closeCouponPopup()">
        <i class="pi pi-times"></i>
      </div>
    </div>
    <div class="ipm-applied-coupon-body">
      <img *ngIf="isSaleLive" class="ipm-diwali-coupon-diya" src="assets/imgs/bpm-diwali-hour-sale/diya.png" alt="Diwali diya">
      <div *ngIf="isSaleLive" class="ipm-diwali-coupon-label">Diwali Special</div>
      <div class="coupon-applied-text">
        <span *ngIf="data?.coupon?.discount?.quantifier === 'percentage'">
          {{ (data?.coupon?.discount?.value / 100) | percent }}
        </span>
        <span *ngIf="data?.coupon?.discount?.quantifier !== 'percentage'">
          {{ data?.coupon?.discount?.value | currency:'INR':'symbol':'0.0-0' }}
        </span>
        OFF Coupon Applied!
      </div>
      <div class="ipm-discount-amount">
        Redeem {{ (data?.coupon?.discount?.value * selectedLicData?.priceDetails?.final_price) / 100
                  | currency:'INR':'symbol':'0.0-0' }} Discount
      </div>
    </div>
  </div>
  <div class="ipm-coupon-checkout-section" [class.ipm-diwali-coupon-checkout-section]="isSaleLive">
    <button class="btn ipm-coupon-checkout-btn" (click)="goToCartWithCoupon()">
      Checkout
    </button>
  </div>
</ng-template>
<ipm-billing-addresses (onSelectedData)="onBillingAddressSelected($event)" [disableAutoPopup]="true" [isHidden]="true" style="display: none;" [defaultDialogType]="'checkoutType'" #billingAddress></ipm-billing-addresses>

<ng-template #mobileTermsTemplate let-data>
  <div class="ipm-lm-mobile-terms">


    <!-- Checklist — uses the same term.icon + term.description as desktop cards -->
    <ul class="ipm-lm-mt-list">
      <ng-container *ngFor="let term of licenseTerms">
        <li class="ipm-lm-mt-item" *ngIf="term.title !== 'Read Full License'">
          <span class="ipm-lm-mt-icon"
                [innerHTML]="getTermIconSvg(term.icon, activeTierMeta?.accent || '#ffffff')"></span>
          <span class="ipm-lm-mt-text">
            <span class="ipm-lm-mt-label">{{ term.title }}</span>
            <span class="ipm-lm-mt-value" *ngIf="term.value">{{ term.value }}</span>
          </span>
        </li>
      </ng-container>
    </ul>
    <!-- "Read full license" link row -->
    <button class="ipm-lm-mt-read-license" type="button" (click)="showSelectedLicense()">
      <span class="ipm-lm-mt-rl-icon"
            [innerHTML]="getTermIconSvg('license', activeTierMeta?.accent || '#ba7cff')"></span>
      <span class="ipm-lm-mt-rl-text">Read full license</span>
    </button>

  </div>
</ng-template>
<ipm-billing-addresses (onSelectedData)="onBillingAddressSelected($event)" [disableAutoPopup]="true" [isHidden]="true" style="display: none;" #billingAddress></ipm-billing-addresses>

<ng-template #paymentSuccessPopup let-data>
    <ipm-payment-success [type]="data.popType"
        [message]="data.message"
        [isShowButton]="true"
        (isCloseButtonEvent)="closePopup($event)"
        [buttonText]="data?.buttonText">
    </ipm-payment-success>
</ng-template>
